import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import StackedBarChart from "../../../../components/charts/StackedBarChart";
import BarChart from "../../../../components/charts/BarExport";
import { useTranslation } from "react-i18next";

export default function TlmExport({ data }) {
  
  const labels = ["Mean", "Median", "95th Percentile"];
  const {t} = useTranslation();

  // Function to format currency values
  const formatCurrency = (value) => {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  };

  return (
    <Box sx={{ bgcolor: "#f9f9f9", fontSize: '0.875rem' }}> {/* Added base font size */}
        <Box
          id={`tlm-threat-2`}
          sx={{
            width: "210mm",
            margin: "auto",
            marginBottom: "20px",
            pageBreakAfter: "always",
            boxShadow: 3,
            borderRadius: 2,
            bgcolor: "#f9f9f9",
            padding: "20px",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
    
            {/* Main Title - UNCHANGED */}
            <Typography
              sx={{
                textAlign: "start",
                fontWeight: "bold",
              }}
              variant='h6'
            >
                4.2 Estimated loss margin by threat scenario
            </Typography>

      {data.map((tlm, index) => (
          <Box
          key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 4,
              justifyContent: "center",
            }}
          >
          {/* Chart Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              width:"97%",
              justifyContent: "center",
              gap: 2,
              mt: 4,
              
            }}
          >
            <Box
              sx={{
  
                width: "100%",
       
                textAlign: "center",
              }}
              >
              <Typography sx={{textAlign: "left", fontSize: "1rem",fontWeight: "bold"}}> {/* Reduced from 27px */}
                  {t(tlm["threat"])}
              </Typography>
              </Box>

            <Box
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                p: 3,
                bgcolor: "background.paper",
                width: "95%",
                minHeight: "100px",
                height: "auto",
                textAlign: "center",
              }}
            >
      
              <StackedBarChart
                values={[tlm?.mean, tlm?.median, tlm?.['95th']]}
                labels={labels}
                min={0}
                max={tlm?.['95th']}
                isExport={true}
                axisFontSize="0.75rem" // Added for chart axis labels
                labelFontSize="0.75rem" // Added for chart data labels
              />
            </Box>

            <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              width:"97%",
              justifyContent: "center",
              gap: 2,
             
              
            }}
          >
          <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 2,
                marginLeft: 1,
              }}
            >
              <Box
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  p: { xs: 2, sm: 3 },
                  bgcolor: "background.paper",
                  width:"93%",
                  
                  height: "auto",
                  textAlign: "start",
                }}
              >
                <Typography sx={{fontSize: '0.8125rem'}}>{tlm?.justification}</Typography> {/* Reduced body text size */}
              </Box>
            </Box>
          </Box>

          </Box>
        </Box>
      ))}

      {data.map((tlm, index) => (
        <Box
        key={index}
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 4,
            justifyContent: "center",
          }}
        >

        </Box>
      ))}
      </Box>
    </Box>
  );
}